// extracted by mini-css-extract-plugin
module.exports = {"group":"Indicators_group__9C2Z8","indicatorLabel":"Indicators_indicatorLabel__YOav4","alignCenter":"Indicators_alignCenter__z9mt6","alignRight":"Indicators_alignRight__zAQwe"};